<template>
  <div ref="products-filter" class="products-filter w-100">
    <div @click="expanded = !expanded" :class="{'expanded': expanded}" class="products-filter__dropdown form-control d-flex flex-column">
      <div class="w-100 products-filter__toggle">
        <span>{{selectText}}</span>
        <div>
          <i v-if="$page.props.category_id" @click.self.stop="clearFilter" class="fas fa-times mr-2 products-filter__close-icon"></i>
          <i class="fas fa-chevron-down products-filter__select-icon"></i>
        </div>
      </div>
    </div>
    <ul v-show="expanded" class="pl-0 pt-2 w-100 products-filter__list dropdown-menu show">
      <li class="nav-item dropdown products-filter__list--item" :key="category.id" v-for="category in productCategories">
        <a
          @click="expandCategory(category)" 
          class="nav-link dropdown-toggle"
          :class="{active: isSelected(category)}"
          :href="route('mtd.shop.category', category)" 
          :id="'navbarDropdown-' + category.id"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ category.name }}
          <i v-if="category.children.length" :class="{expanded: category.expanded}" class="products-filter__list--icon fas fa-caret-down"></i>
        </a>
        <div v-if="category.children.length" class="dropdown-menu w-100" aria-labelledby="navbarDropdown">
          <a class="dropdown-item font-weight-bold" @click="viewCategory(categoryRoute, category)">All {{ category.name }}</a>
          <a 
            class="dropdown-item"
            :class="{'subcategory-active': subcategory.id === $page.props.category_id}"
            @click="viewCategory(categoryRoute, subcategory)" 
            v-for="subcategory in category.children"
            :key="subcategory.id">
              {{ subcategory.name }}
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
      productCategories: this.categories,
      selectText: this.getCategory()
    }
  },
  mounted() {
    this.resetDropdownState()
    window.addEventListener('click', this.clickedOutside)
  },
  unmounted() {
    window.removeEventListener('click', this.clickedOutside)
  },
  props: {
    categories: Array,
    shopRoute: String,
    categoryRoute: String
  },
  methods: {
    clickedOutside(event) {
      if (!this.$refs['products-filter'].contains(event.target)) {
        this.expanded = false
        this.resetDropdownState()
      }
    },
    resetDropdownState() {
      this.productCategories.forEach(elem => elem.expanded = false)
    },
    clearFilter() {
      const queryObject = this.mergeQueryParams({
          manufacturer: this.$page.props.manufacturer_id,
          query: this.$page.props.query
        })

      this.selectText = 'Select Product'
      this.$inertia.visit(this.route(this.categoryRoute, {
        category: '',
        _query: queryObject
      }))
    },
    expandCategory(category) {
      if (!category.children.length) {
        this.viewCategory(this.categoryRoute, category)
        return
      }
      this.productCategories.forEach(elem => {
        if (category.id !== elem.id) elem.expanded = false
      })
      category.expanded = !category.expanded
    },
    isSelected(category) {
      const hasActiveChild = category.children.filter(child => {
        return child.id === this.$page.props.category_id
      }).length

      return this.$page.props.category_id===category.id || hasActiveChild
    },
    viewCategory(route, category) {
      const queryObject = this.mergeQueryParams({
          manufacturer: this.$page.props.manufacturer_id,
          query: this.$page.props.query
        })

      this.$inertia.visit(this.route(route, { category, _query: queryObject, }))
    },
    getCategory() {
      const categories = this.$page.props.categories
      if (this.$page.props.category_id) {
        for (let i=0; i<categories.length; i++) {
          if(Number(categories[i].id) === (this.$page.props.category_id)) {
            this.$emit('category', categories[i].name)
            return categories[i].name
          }

          // Loop through category children too
          const children = categories[i].children
          for(let e=0; e<children.length; e++) {
            if(Number(children[e].id) === (this.$page.props.category_id)) {
              this.$emit('category', children[e].name)
              return children[e].name
            }
          }
        }
      } else return 'Select Category'
    }
  }
}
</script>
